import { createContext } from 'react';

const ReviewRequestDialogContext = createContext();

export default ReviewRequestDialogContext;
